import { computed, ref } from '@nuxtjs/composition-api';
import { toPartsDbVehicleSummary } from '@shared/composables/useVehicleManualSearch/helpers';
import { PartsDbVehicleSummary } from '@unified-commerce/gpc-vue-storefront-parts-db';
import {
  useVehicleSearch,
  VehicleSearchOptions,
} from '@unified-commerce/gpc-vue-storefront-search';

const useVirtualVehicleSearch = () => {
  const virtualVehicles = ref<PartsDbVehicleSummary[]>([]);

  const {
    search,
    result,
    loading,
    error: vehicleSearchError,
  } = useVehicleSearch('virtual-vehicle-search');

  const reset = () => {
    virtualVehicles.value = [];
  };

  const searchVirtualVehicles = async (vehicleIds: string[], exactYear: string) => {
    const searchUpdatedIDFilters = `(${vehicleIds
      .map((v) => `Parent:${v}`)
      .join(' OR ')}) AND YearFrom<=${exactYear} AND YearTo>=${exactYear}`;

    const updatedSearchIDOptions: VehicleSearchOptions = {
      resultsPerPage: vehicleIds.length,
      filters: searchUpdatedIDFilters,
    };

    await search(updatedSearchIDOptions);

    virtualVehicles.value = (result.value.results ?? [])?.flatMap((result) =>
      result.hits.map(toPartsDbVehicleSummary),
    );
  };

  const error = computed(() => vehicleSearchError.value.search);

  return {
    reset,
    loading,
    virtualVehicles,
    searchVirtualVehicles,
    error,
  };
};

export default useVirtualVehicleSearch;
